import { render, staticRenderFns } from "./MainMiddlePanelForCuratorAndTeacher.vue?vue&type=template&id=54c6bec4&scoped=true&"
import script from "./MainMiddlePanelForCuratorAndTeacher.vue?vue&type=script&lang=js&"
export * from "./MainMiddlePanelForCuratorAndTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c6bec4",
  null
  
)

export default component.exports